import { useState } from "react"

import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { snackbar } from "../../../../utils/general/generalUtils"
import { postClientProtected } from "../../clients/clients"
import { DNO_ADD_COMMENT, INSTALLER_ADD_COMMENT } from "../../urls/hybrid"

interface IAddApplicationCommentHook {
    isSending: boolean
    error: IAppError | undefined
    postResponse: (
        applicationId: string,
        comment: string,
        isDno: boolean
    ) => Promise<void>
}

const useAddApplicationComment = (): IAddApplicationCommentHook => {
    const [isSending, setIsSending] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const postResponse = async (
        applicationId: string,
        comment: string,
        isDno: boolean
    ): Promise<void> => {
        try {
            let url
            setIsSending(true)
            if (isDno) {
                url = DNO_ADD_COMMENT(applicationId)
            } else {
                url = INSTALLER_ADD_COMMENT(applicationId)
            }
            await postClientProtected(url, { comment })
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
        } finally {
            if (!isDno) {
                snackbar(
                    "A comment does not constitute a formal notification of a connection to your DNO",
                    "default"
                )
            }
            setIsSending(false)
        }
    }

    return {
        error,
        isSending,
        postResponse,
    }
}

export default useAddApplicationComment
